import React from 'react';
import { formatDateToISO, getSlotHHMM, formatTimeSlot, formatSlotToISO, getDayName, getDayNumber, isSlotInFuture } from '../../utils/helpers';

interface ListViewProps {
  visibleDates: Date[];
  slotsByDate?: Record<string, Record<string, string[]>>;
  selectedSlot: string | null;
  onSlotSelect: (slotId: string) => void;
  onOperatoriesSelect?: (operatories: string[]) => void;
  bufferMinutes?: number;
}

const ListView: React.FC<ListViewProps> = ({
  visibleDates,
  slotsByDate,
  selectedSlot,
  onSlotSelect,
  onOperatoriesSelect,
  bufferMinutes = 0,
}) => {
  return (
    <div className="max-h-[370px] overflow-y-auto divide-y divide-gray-100">
      {visibleDates.map((date, index) => {
        const dateStr = formatDateToISO(date);
        const timeSlotsObj = slotsByDate?.[dateStr] || {};
        const timeSlots = Object.keys(timeSlotsObj)
          .filter((slot) => isSlotInFuture(dateStr, slot, bufferMinutes))
          .sort((a, b) => {
            const [ah, am] = getSlotHHMM(a).split(':').map((n) => parseInt(n || '0', 10));
            const [bh, bm] = getSlotHHMM(b).split(':').map((n) => parseInt(n || '0', 10));
            return ah * 60 + am - (bh * 60 + bm);
          });

        return (
          <div key={index} className="flex flex-col sm:flex-row gap-0 sm:gap-3 py-3">
            <div className="w-full sm:w-24 flex flex-shrink-0 items-center justify-center bg-black sm:bg-white rounded-lg sm:rounded-none sticky top-0 z-10">
              <div className="text-xs sm:text-sm font-semibold text-white sm:text-gray-900 py-2 sm:p-0">
                {getDayName(date)}, {date.toLocaleDateString('en-US', { month: 'short' })} {getDayNumber(date)}
              </div>
            </div>

            {/* Time Slots for this day */}
            <div className="flex flex-wrap gap-2 px-0 sm:px-2 pt-2 sm:pt-0">
              {timeSlots.length === 0 ? (
                <span className="text-center w-full sm:text-left sm:text-sm text-xs text-gray-400 italic py-2">
                  Closed / No Slots Available
                </span>
              ) : (
                timeSlots.map((slot) => {
                  const slotId = formatSlotToISO(dateStr, slot);
                  const isSelected = selectedSlot === slotId;
                  const operatories_available = timeSlotsObj[slot];

                  return (
                    <button
                      key={slot}
                      onClick={() => {
                        onSlotSelect(slotId);
                        if (onOperatoriesSelect) onOperatoriesSelect(operatories_available || []);
                      }}
                      className={`
                        px-2 py-3 text-xs rounded font-medium transition-all duration-200 border
                        ${isSelected ? 'bg-teamcare-yellow text-black border-teamcare-yellow' : 'bg-white text-gray-700 border-gray-200 hover:border-teamcare-yellow hover:text-teamcare-yellow'}
                      `}
                    >
                      {formatTimeSlot(slot)}
                    </button>
                  );
                })
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ListView;
